/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Transaction priority levels */
export enum TransactionPriority {
  Low,
  Normal,
  High,
  Critical,
  Emergency,
}

export type TransactionPriorityArgs = TransactionPriority;

export function getTransactionPriorityEncoder(): FixedSizeEncoder<TransactionPriorityArgs> {
  return getEnumEncoder(TransactionPriority);
}

export function getTransactionPriorityDecoder(): FixedSizeDecoder<TransactionPriority> {
  return getEnumDecoder(TransactionPriority);
}

export function getTransactionPriorityCodec(): FixedSizeCodec<
  TransactionPriorityArgs,
  TransactionPriority
> {
  return combineCodec(
    getTransactionPriorityEncoder(),
    getTransactionPriorityDecoder(),
  );
}
